<template>
  <div>
    <div id="login" class="container mt-5">
      <div class="center-content">
        <h1>Login</h1>
        <form id="login-form" class="form-floating" @submit.prevent="login">
          <div class="row">
            <div class="col">
              <div class="mb-3 form-floating">
                <input type="email" class="form-control" id="email_login" ref="email_login" required>
                <label for="email_login" class="form-label">Indirizzo e-mail:</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="mb-3 form-floating">
                <input type="password" class="form-control" id="password_login" ref="password_login"
                       required>
                <label for="password_login" class="form-label">Password:</label>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary" id="loginButton" :disabled="loadingState_login">
            <div class="spinner-border" role="status" v-if="loadingState_login">
              <span class="visually-hidden">Loading...</span>
            </div>
            <div v-else>
              Login
            </div>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {signInWithEmailAndPassword} from "firebase/auth";
import {auth} from "@/utils/js/firebase";
import {useHead} from "@vueuse/head";


export default {
  name: 'Login',
  setup() {
    useHead({
      title: 'VISAD Dashboard - Login'
    });
  },
  data() {
    return {
      loadingState_login: false
    }

  },
  methods: {
    async login() {
      this.loadingState_login = true;
      signInWithEmailAndPassword(auth, this.$refs.email_login.value, this.$refs.password_login.value)
        .then(async (userCredential) => {
          this.$refs.password_login.value = '';
          // Signed in
          const user = userCredential.user;

          console.log(user);
          localStorage.setItem("user-info", JSON.stringify({
              id: user.uid,
              expiry: (Date.now() + 60 * 60 * 1000).toString()
            })
          );
          // setTimeout(() => {
          this.loadingState_login = false;
          this.$router.push('/');
          // }, 5000);


          // } else {
          //   this.loadingState_login = false;
          //   alert("Wrong credentials or maybe you haven't signed up yet!");
          // }
        })
        .catch((error) => {
          console.log(error.code);
          console.log(error.message);

          if (error.code === "auth/invalid-credential") {
            this.loadingState_login = false;
            alert("Wrong credentials or maybe you haven't signed up yet!");
          }

        });
    },
  }
}


</script>

<style scoped>
</style>